import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/context/ThemeContext";

const SECTIONS = [
  ["Données collectées", "Ton nom, ton adresse e-mail et ta photo de profil (via Google), les transcriptions et notes de tes cours, et ton nombre de minutes de transcription utilisées."],
  ["Enregistrements audio", "L'audio est transmis de façon chiffrée (HTTPS) uniquement pendant que tu enregistres ou importes un fichier, transcrit par notre prestataire d'IA, puis supprimé. Il n'est jamais conservé ni publié, et n'est jamais utilisé pour entraîner une intelligence artificielle."],
  ["Durée de conservation", "Tes cours sont conservés pendant la durée choisie dans ton profil (30, 90, 180 jours ou 1 an), puis supprimés automatiquement."],
  ["Tes droits (RGPD)", "Tu peux à tout moment exporter tes données, supprimer un cours, supprimer tous tes enregistrements ou supprimer définitivement ton compte depuis ton profil."],
  ["Mineurs", "Les élèves de moins de 15 ans doivent avoir l'accord d'un parent ou représentant légal pour utiliser le service. Un abonnement payant nécessite d'être majeur ou que le représentant légal l'autorise et effectue le paiement."],
];

export default function Privacy() {
  return (
    <div className="min-h-screen px-5 pb-24" data-testid="privacy-page">
      <div className="mx-auto flex max-w-3xl items-center justify-between py-6"><Logo /><ThemeToggle /></div>
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Retour</Link>
        <h1 className="mt-6 text-4xl font-extrabold tracking-tight">Confidentialité & conditions</h1>
        <div className="mt-10 space-y-8">
          {SECTIONS.map(([t, d]) => (
            <section key={t}><h2 className="text-xl font-bold">{t}</h2><p className="mt-2 text-muted-foreground">{d}</p></section>
          ))}
          <section id="conditions">
            <h2 className="text-xl font-bold">Conditions d'utilisation</h2>
            <ul className="mt-2 list-disc space-y-1.5 pl-5 text-muted-foreground">
              <li>N'enregistre un cours qu'avec l'autorisation du professeur et des personnes concernées, et dans le respect du règlement de ton établissement.</li>
              <li>N'enregistre jamais quelqu'un à son insu. L'enregistrement clandestin est interdit.</li>
              <li>Les notes générées par l'IA peuvent contenir des erreurs : vérifie-les, en particulier les passages signalés.</li>
              <li>Tes notes sont destinées à ton usage personnel : ne les diffuse pas sans l'accord des personnes concernées.</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
